module.exports = __webpack_public_path__ + "static/beet-28fd1620db8a340acfbafef3cedcd2d2.svg";